import {Box, Grid, Input, Typography, Button, TextField, CircularProgress} from '@mui/material';
import * as React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import {setSnackbar} from "../../../store/reducers/globals";
import { usePapaParse } from 'react-papaparse';
import {AgyleNamedIcon} from "../../../components/icons/agyle";
import CloseIcon from '@mui/icons-material/Close';
import * as _ from "lodash";
import {AdminAPI} from "../admin_api";
import config from '../../../app/config';
import clsx from 'clsx';
import {DatePicker} from '@mui/lab';
import moment from 'moment';
import {Fragment, useEffect} from 'react';
import AgyleLoadingSpinner from '../../../components/other/agyleLoadingSpinner';

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        marginLeft: "10px",
        marginRight: "10px"
    },
    itemIcon: {
        paddingTop: "7px"
    },
    iconAttachment: {
        color: "#448FFF",
    },
    remove: {
        cursor: "pointer"
    },
    openUpload: {
        backgroundColor: "#BFD8FF",
        color: "#448FFF",
        "&:hover": {
            backgroundColor: "#84b1ff",
            color: "#ffffff",
        }
    },
    start: {
        backgroundColor: "#448FFF"
    },
    cancel: {
        backgroundColor: "#ff8282",
        "&:hover": {
            backgroundColor: "#ff2a2a",
        }
    },
    hiddenInput: {
        display: "none"
    },
    importBlock: {
        border: "1px solid #727272",
        marginLeft: "0px",
        borderRadius: "10px",
        padding: "20px",
        background: theme.palette.nhsUpsertBlock.background,

},
    importName: {
        padding: "5px"
    }
}));

function NhsUpsertData(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const { readString } = usePapaParse();
    const [ward, setWard] = React.useState("false");
    const [dateFrom, setDateFrom] = React.useState(moment());
    const [groupNameForImport, setGroupNameForImport] = React.useState("");
    const [lastUpsertConsultantStr, setlastUpsertConsultantStr] = React.useState('-');
    const [lastUpsertGpsStr, setlastUpsertGpsStr] = React.useState('-');
    const [lastUpsertSurgeriesStr, setlastUpsertSurgeriesStr] = React.useState('-');
    const [lastSyncSurgeriesStr, setlastSyncSurgeriesStr] = React.useState("-");
    const [loading, setLoading] = React.useState(false);
    const [filesToImport, setFilesToImport] = React.useState({
        "gp_data": [],
        "gp_surgeries_data": [],
        "consultants_data": []
    });

    const disableEnterKey = (e) => {
        e.stopPropagation();
        return false;
    };

    useEffect(()=>{
        getStats();
    },[]);

    const getStats = () => {
        setlastUpsertConsultantStr("...");
        setlastUpsertGpsStr("...");
        setlastUpsertSurgeriesStr("...");
        setlastSyncSurgeriesStr("...");
        AdminAPI.getNhsUpsertStat("upsertConsultant").then((stat) => {
            if(stat) {
                let lastUpsertConsultant = moment(stat.createdDate);
                setlastUpsertConsultantStr(`Recently performed ${lastUpsertConsultant.format("YYYY-MM-DD HH:mm")} by ${stat.createdBy}`)
            }
        })
        AdminAPI.getNhsUpsertStat("upsertGps").then((stat) => {
            if(stat) {
                let lastUpsertGps = moment(stat.createdDate);
                setlastUpsertGpsStr(`Recently performed ${lastUpsertGps.format("YYYY-MM-DD HH:mm")} by ${stat.createdBy}`);
            }
        })
        AdminAPI.getNhsUpsertStat("upsertSurgeries").then((stat) => {
            if(stat) {
                let lastUpsertSurgeries = moment(stat.createdDate);
                setlastUpsertSurgeriesStr(`Recently performed ${lastUpsertSurgeries.format("YYYY-MM-DD HH:mm")} by ${stat.createdBy}`);
                // if(this.lastUpsertSurgeries && this.lastUpsertSurgeries.isValid()
                //     &&)
            }
        })
        AdminAPI.getNhsUpsertStat("syncSurgeries").then((stat) => {
            if(stat) {
                let lastSyncSurgeries = moment(stat.createdDate);
                setDateFrom(lastSyncSurgeries);
                setlastSyncSurgeriesStr(`Recently performed ${lastSyncSurgeries.format("YYYY-MM-DD HH:mm")} by ${stat.createdBy}`);
            }
        })
    }

    const handleOpenNewElementBox = (type, edit) => {
        if(type == "open") {
            document.getElementById("uploadDocSelect").click();
            setGroupNameForImport(edit);
        }
        if(type == "cancel") {
            let fti = {...filesToImport};
            fti[edit] = [];
            setFilesToImport(fti);
        }
        if(type == "startUpload") {
            tryImportFiles(filesToImport[edit],edit);
        }
    };

    const tryImportFiles = (filesList,target) => {

        let upsertTarget;
        switch (target){
            case "gp_data":
                upsertTarget = "upsertGp";
                break;
            case "gp_surgeries_data":
                upsertTarget = "upsertSurgery";
                break;
            case "consultants_data":
                upsertTarget = "upsertConsultant";
                break;
        }
        if(upsertTarget) {
            if(filesList && filesList.length==1) {
                setLoading(true);
                AdminAPI.sendData(filesList[0].data, filesList[0].name, upsertTarget).then((result) => {
                    if(result.status == "ok") {
                        dispatch(setSnackbar({type: "info", message: t("Data send.")}));
                        handleOpenNewElementBox("cancel", target);
                        getStats();
                    } else {
                        dispatch(setSnackbar({type: "error", message: result.data}));
                    }
                    setLoading(false);
                })
            } else {
                dispatch(setSnackbar({type: "error", message: t("No file selected to import")}));
            }
        } else {
            if(target === "gp_surgeries_data_sync") {
                if(moment().diff(dateFrom, 'days')>=185) {
                    dispatch(setSnackbar({type: "error", message: t("Supplied last change date exceeds the limit of 185 days past.")}));
                }else {
                    setLoading(true);
                    AdminAPI.syncSurgeries(dateFrom).then((result) => {
                        if (result.status == "ok") {
                            dispatch(setSnackbar({type: "info", message: t("Synchronized successfully.")}));
                            handleOpenNewElementBox("cancel", target);
                            getStats();
                        } else {
                            dispatch(setSnackbar({type: "error", message: result.data}));
                        }
                        setLoading(false);
                    }).catch((err) => {
                        setLoading(false);
                        dispatch(setSnackbar({type: "error", message: err}));
                    })
                }
            } else {
                dispatch(setSnackbar({type: "error", message: t("Not recognize upsert data store name")}));
                console.error("Not recognize upsert data store name");
            }
        }
    }

    const selectFile = (event) => {
        const file = event.target.files[0];
        if(file) {
            let fti = {...filesToImport};
            let searchItemIndex = _.findIndex(fti[groupNameForImport], (el) => {
                return el.name == file.name;
            });
            if(searchItemIndex == -1) {
                let item = {
                    name: file.name,
                    data: file
                }
                fti[groupNameForImport] = [item];
                //fti[groupNameForImport].push(item);
                setFilesToImport(fti);
                event.target.value = null;
            } else {
                dispatch(setSnackbar({type: "warning", message: t("File name already added")}));
            }
        } else {
            dispatch(setSnackbar({type: "warning", message: t("No file selected")}));
        }
        //console.log("open selected file", event, event.target.files);
    }

    const removeItem = (group, item) => {
        let fti = {...filesToImport};
        let index = _.findIndex(fti[group], (el) => {
            return el.name == item.name && el.data.length == item.data.length;
        });
        if(index > -1){
            fti[group].splice(index, 1);
            setFilesToImport(fti);
        }
    }

    return (
        <>
        {loading &&
            // <CircularProgress style={{color: '#fff'}} size={20}/>
            <Box sx={{ width: '100%', padding: '15px'}}>
                <AgyleLoadingSpinner label={'Process is in progress do not leave this page until is finished'}/>
            </Box>
        }
        {!loading &&
            <Fragment>
        <Box sx={{ width: '100%', padding: '15px'}}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography>
                        {t("Upsert GP Data")}
                    </Typography>
                </Grid>
                <Grid item spacing={3} xs={12}>
                    <Grid container className={classes.importBlock}>
                        <Grid item xs={3} sx={{padding: '5px'}}>
                            {t("GP Date (egpcur.csv)")}
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={[classes.fullWidth, classes.openUpload].join(" ")}
                                disabled={!ward}
                                variant={"contained"}
                                startIcon={<AgyleNamedIcon name={"upload2"}/>}
                                onClick={handleOpenNewElementBox.bind(this, "open", "gp_data")}
                                onKeyDown={disableEnterKey}
                                disableRipple
                                disableElevation
                                disableFocusRipple
                            >
                                {t("Upload file")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={[classes.fullWidth, classes.start].join(" ")}
                                disabled={!ward}
                                variant={"contained"}
                                onClick={handleOpenNewElementBox.bind(this, "startUpload", "gp_data")}
                                onKeyDown={disableEnterKey}
                                disableRipple
                                disableElevation
                                disableFocusRipple>
                                {t("Start upload")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            {lastUpsertGpsStr}
                        </Grid>
                        <Grid item xs={6}>
                            <table>
                                <tbody>
                                {filesToImport["gp_data"].map((f, index) => {
                                    return (<tr key={"gp_data_" + index}>
                                        <td className={[classes.itemIcon, classes.iconAttachment].join(" ")}><AgyleNamedIcon name={"attachment"}/></td>
                                        <td>{f.name}</td>
                                        <td className={[classes.itemIcon, classes.remove].join(" ")}><CloseIcon onClick={() => removeItem("gp_data", f)}/></td>
                                    </tr>)
                                })}
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container className={classes.importBlock}>
                        <Grid item xs={3} sx={{padding: '5px'}}>
                            {t("Upload GP Surgeries Data (epraccur.csv)")}
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={[classes.fullWidth, classes.openUpload].join(" ")}
                                disabled={!ward}
                                variant={"contained"}
                                startIcon={<AgyleNamedIcon name={"upload2"}/>}
                                onClick={handleOpenNewElementBox.bind(this, "open", "gp_surgeries_data")}
                                onKeyDown={disableEnterKey}
                                disableRipple
                                disableElevation
                                disableFocusRipple
                            >
                                {t("Upload file")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={[classes.fullWidth, classes.start].join(" ")}
                                disabled={!ward}
                                variant={"contained"}
                                onClick={handleOpenNewElementBox.bind(this, "startUpload", "gp_surgeries_data")}
                                onKeyDown={disableEnterKey}
                                disableRipple
                                disableElevation
                                disableFocusRipple>
                                {t("Start upload")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            {lastUpsertSurgeriesStr}
                        </Grid>
                        <Grid item xs={6}>
                            <table>
                                <tbody>
                                {filesToImport["gp_surgeries_data"].map((f, index) => {
                                    return (<tr key={"gp_surgeries_data_" + index}>
                                        <td className={[classes.itemIcon, classes.iconAttachment].join(" ")}><AgyleNamedIcon name={"attachment"}/></td>
                                        <td>{f.name}</td>
                                        <td className={[classes.itemIcon, classes.remove].join(" ")}><CloseIcon onClick={() => removeItem("gp_surgeries_data", f)}/></td>
                                    </tr>)
                                })}
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                </Grid>
                {config?.trudSurgieriesApiSync &&
                    <Grid item xs={12}>
                        <Grid container className={classes.importBlock}>
                            <Grid item xs={3} sx={{padding: '5px'}}>
                                {t("Synchronize GP Surgeries Data via NHS api, have beed modified since:")}
                            </Grid>
                            <Grid item xs={3}>
                                <DatePicker
                                    className={classes.datePicker}
                                    label={t("From")}
                                    inputFormat={config.defaultDateFormat}
                                    value={dateFrom}
                                    onChange={(e)=> setDateFrom(e)}
                                    renderInput={(inp) => <TextField className={classes.datePicker}{...inp} size={"small"}/>}
                                    inputVariant="outlined"
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    className={[classes.fullWidth, classes.start].join(" ")}
                                    disabled={!ward}
                                    variant={"contained"}
                                    onClick={handleOpenNewElementBox.bind(this, "startUpload", "gp_surgeries_data_sync")}
                                    onKeyDown={disableEnterKey}
                                    disableRipple
                                    disableElevation
                                    disableFocusRipple>
                                    {t("Synchronize")}
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                                {lastSyncSurgeriesStr}
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid item xs={12}>
                    <Typography>
                        {t("Upsert Consultants Data")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container className={classes.importBlock}>
                        <Grid item xs={3} sx={{padding: '5px'}}>
                            {t("Upsert Consultants data (econcur.csv)")}
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={[classes.fullWidth, classes.openUpload].join(" ")}
                                disabled={!ward}
                                variant={"contained"}
                                startIcon={<AgyleNamedIcon name={"upload2"}/>}
                                onClick={handleOpenNewElementBox.bind(this, "open", "consultants_data")}
                                onKeyDown={disableEnterKey}
                                disableRipple
                                disableElevation
                                disableFocusRipple
                            >
                                {t("Upload file")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={[classes.fullWidth, classes.start].join(" ")}
                                disabled={!ward}
                                variant={"contained"}
                                onClick={handleOpenNewElementBox.bind(this, "startUpload", "consultants_data")}
                                onKeyDown={disableEnterKey}
                                disableRipple
                                disableElevation
                                disableFocusRipple>
                                {t("Start upload")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            {lastUpsertConsultantStr}
                        </Grid>
                        <Grid item xs={6}>
                            <table>
                                <tbody>
                                {filesToImport["consultants_data"].map((f, index) => {
                                    return (<tr key={"consultants_data_" + index}>
                                        <td className={[classes.itemIcon, classes.iconAttachment].join(" ")}><AgyleNamedIcon name={"attachment"}/></td>
                                        <td>{f.name}</td>
                                        <td className={[classes.itemIcon, classes.remove].join(" ")}><CloseIcon onClick={() => removeItem("consultants_data", f)}/></td>
                                    </tr>)
                                })}
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <input id="uploadDocSelect" className={classes.hiddenInput} onChange={selectFile} type="file" accept=".csv"/>
        </Box></Fragment>
        }
        </>)
}
export default NhsUpsertData;